import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Row, Col, Input, message } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import { CreateButton } from '../../components/AppButton'
import Table from './Table'
import {
  fetchItems,
  changeTable,
  searchTable,
  editSearch,
} from '../../actions/cvSelectedCasesCaseList'
import { LIST_PAGESIZE } from '../../constants/app'

const { Search } = Input
const pageTitle = 'Cv Selected Cases Cases'
const storeKey = 'cvSelectedCasesCaseList'
const createPath = (memberId, casesId) => `/admin/members/${memberId}/cv_selected_cases/${casesId}/cases/create`
const editPath = (memberId, casesId) => `/admin/members/${memberId}/cv_selected_cases/${casesId}/cases/edit`

class ItemList extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleCreateButtonOnClick = this.handleCreateButtonOnClick.bind(this)
    this.handleTableOnChange = this.handleTableOnChange.bind(this)
    this.handleSearchOnChange = this.handleSearchOnChange.bind(this)
    this.handleSearchOnClick = this.handleSearchOnClick.bind(this)
    this.handleSearchOnCancel = this.handleSearchOnCancel.bind(this)
  }

  componentDidMount() {
    this.fetchItems({ casesId: this.props.match.params.casesId })
    const { isSearching } = this.props
    !isSearching && this.props.editSearch({ search: null })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isFetchItemsLoading && nextProps.fetchItemsError) {
      message.error(nextProps.fetchItemsError)
    }
  }

  fetchItems({ casesId }) {
    const {
      pagination = {},
      sorter = {},
      search,
      isSearching,
    } = this.props
    this.props.fetchItems({
      current: pagination.current,
      pageSize: pagination.pageSize,
      sort: sorter.columnKey,
      order: sorter.order,
      search: (isSearching && search) || null,
      casesId,
    })
  }

  handleCreateButtonOnClick(e) {
    e.preventDefault()
    this.props.history.push(createPath(this.props.match.params.memberId, this.props.match.params.casesId))
  }

  async handleTableOnChange(pagination, filters, sorter) {
    const { columnKey, field, order } = sorter
    await this.props.changeTable({
      pagination,
      filters,
      sorter: {
        columnKey,
        field,
        order,
      },
    })
    this.fetchItems({ casesId: this.props.match.params.casesId })
  }

  handleSearchOnChange(e) {
    e.preventDefault()
    const search = e.target.value
    this.props.editSearch({ search })
    if (!search) {
      this.props.searchTable({ isSearching: false })
    }
  }

  async handleSearchOnClick() {
    await this.props.searchTable({ isSearching: true })
    await this.props.changeTable({})
    this.fetchItems({ memberId: this.props.match.params.memberId })
  }

  async handleSearchOnCancel(e) {
    e.preventDefault()
    await this.props.editSearch({ search: null })
    await this.props.searchTable({ isSearching: false })
    await this.props.changeTable({})
    this.fetchItems({ memberId: this.props.match.params.memberId })
  }

  render() {
    return (
      <div>
        <AdminLayout>
          <SectionHeader>
            <SectionHeaderTemplate
              breadcrumbRoutes={[{ path: '/admin', title: 'Home' }, { path: '/admin/members', title: 'Members' }, { path: `/admin/members/${this.props.match.params.memberId}/cv_selected_cases`, title: 'Selected Cases' }, { title: pageTitle }]}
              title={pageTitle}
            />
          </SectionHeader>
          <SectionContent borderless>
            <Row type='flex' justify='space-between' style={{ marginBottom: '24px' }}>
              <Col>
                <CreateButton
                  onClick={this.handleCreateButtonOnClick}
                />
              </Col>
              <Col>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Search
                    onChange={this.handleSearchOnChange}
                    onSearch={this.handleSearchOnClick}
                    value={this.props.search}
                    enterButton
                  />
                  {
                    this.props.isSearching &&
                    <a href='' onClick={this.handleSearchOnCancel} style={{ lineHeight: 1.5, marginLeft: '12px' }}>
                      Cancel
                    </a>
                  }
                </div>
              </Col>
            </Row>
            <Table
              loading={this.props.isFetchItemsLoading}
              dataSource={this.props.items || []}
              pagination={this.props.pagination}
              filters={this.props.filters}
              sorter={this.props.sorter}
              onChange={this.handleTableOnChange}
              editPath={editPath(this.props.match.params.memberId, this.props.match.params.casesId)}
            />
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    items,
    total,
    isFetchItemsLoading,
    pagination = {},
    filters,
    sorter,
    search,
    isSearching,
    fetchItemsError,
  } = state[storeKey]
  const editedPagination = {
    ...pagination,
    pageSize: pagination.pageSize || LIST_PAGESIZE,
    pagination: pagination.current || 1,
  }
  return {
    items,
    total,
    isFetchItemsLoading,
    pagination: editedPagination,
    filters,
    sorter,
    search,
    isSearching,
    fetchItemsError,
  }
}

const mapDispatchToProps = dispatch => ({
  fetchItems: params => dispatch(fetchItems(params)),
  changeTable: params => dispatch(changeTable(params)),
  editSearch: search => dispatch(editSearch(search)),
  searchTable: search => dispatch(searchTable(search)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemList))
